import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import Home2 from "../views/ReglementPro";
import HomeEs from "../views/HomeEs.vue";
import HomePart from "../views/ReglementPart";
import PageNotFound from "../views/PageNotFound.vue";

var consts = require('../../config');
Vue.use(Router);

var uri = window.location.href;
var reglementuri = uri.match(/win.mypromodistrigo.com/g);
var reglementuriPart = uri.match(/conditions.mypromodistrigo.com/g);
var specEs = uri.match(/euroreparpromo.com/g);
const myhome = (specEs) ? HomeEs : (reglementuri ) ? Home2 : (reglementuriPart ) ? HomePart : Home

const router = new Router({
  mode: "history",
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: myhome
    },
    {
      path: "/form/:_lang",
      name: "dataform",
      component: () => import("../views/DataForm.vue")
    },
    {
      path: "/privacypolicy/:_lang",
      name: "privacypolicy",
      component: () => import("../views/PrivacyPolicy.vue")
    },
    {
      path: "/legalnotice/:_lang",
      name: "legalnotice",
      component: () => import("../views/LegalNotice.vue")
    },
    {
      path: "/waiting",
      name: "waiting",
      component: () => import("../views/Waiting.vue")
    },
    {
      path: "/finished",
      name: "finished",
      component: () => import("../views/Finished.vue")
    },      
    {
      path: "/reglements",
      name: "reglements",
      component: () => import("../views/ReglementPro.vue")
    },       
    {
      path: "/status/:_lang/:_id/:_uid",
      name: "status",
      component: () => import("../views/Status.vue")
    },            
    {
      path: "/confirmation/:_lang",
      name: "confirmation",
      component: () => import("../views/Confirmation.vue")
    },
    { path: "*", component: PageNotFound }
  ]
});


export default router;

router.beforeEach(async (to, from, next) => {

  window.ga =
  window.ga ||
  function() {
    (ga.q = ga.q || []).push(arguments);
  };
  ga.l = +new Date();
  ga("create", "UA-123759092-29", "auto");
  ga("set", to.name, to.path);
  ga("send", "pageview");

 // if (location.protocol !== 'https:') {
 //   location.replace(`https:${location.href.substring(location.protocol.length)}`);/
//}


  var uri = window.location.href;
  var staging = uri.match(/staging/g);
  var local = uri.match(/localhost/g);
  var prodheroku = uri.match(/herokuapp/g);
  next();
 

});

